export default "__VITE_ASSET__aPh$1A2p__"